import { z } from 'zod'

export const idSchema = z.string().regex(/^[a-z]{3}_[0-9A-HJKMNP-TV-Z]{26}$/, 'Invalid id')
export const slugSchema = z
  .string()
  .min(2)
  .max(80)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use lowercase letters, numbers and dashes')
export const emailSchema = z.string().trim().toLowerCase().email().max(254)
export const isoDateTimeSchema = z.string().datetime({ offset: true })
export const centsSchema = z.number().int().min(0).max(100_000_000)
export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(25),
})

export type Pagination = z.infer<typeof paginationSchema>

export interface Page<T> {
  items: T[]
  page: number
  pageSize: number
  total: number
}

export const addressSchema = z.object({
  addressLine1: z.string().max(200).nullable().optional(),
  addressLine2: z.string().max(200).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  state: z.string().max(50).nullable().optional(),
  postalCode: z.string().max(20).nullable().optional(),
  country: z.string().max(2).nullable().optional(),
})

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().nullable(),
  }),
})
export type ApiError = z.infer<typeof apiErrorSchema>

/**
 * What removing a record will do: a hard delete when nothing else refers to it, otherwise an
 * archive (hidden everywhere public and from default admin lists, history kept). `attached` lists
 * what is keeping it, for the confirmation dialog.
 */
export interface RemovalPlan {
  action: 'delete' | 'archive'
  /** Already archived: nothing more to do unless it can now be deleted. */
  archived: boolean
  attached: { label: string; count: number }[]
  /** Removed along with it when deleted (e.g. shifts, schedule sessions). */
  alsoDeleted: { label: string; count: number }[]
}
